import { render, staticRenderFns } from "./centerTable.vue?vue&type=template&id=0a98fea8&scoped=true"
import script from "./centerTable.vue?vue&type=script&lang=js"
export * from "./centerTable.vue?vue&type=script&lang=js"
import style0 from "./centerTable.vue?vue&type=style&index=0&id=0a98fea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98fea8",
  null
  
)

export default component.exports